exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0739e9ee] .el-tabs__header{margin-bottom:0}.el-dropdown-link[data-v-0739e9ee]{cursor:pointer;color:#90c328}[data-v-0739e9ee] #list_table .el-button+.el-button{margin-left:0}", ""]);

// exports
